export default {
	en: {
		translation: {
			crop: {
				title: "Crop",
				crop_btn: "Crop",
				skip_btn: "Skip",
				reset_btn: "Reset",
				close_btn: "Yes",
				close_prompt: "Closing will cancel all uploads, Are you sure?",
				image_error: "Error loading image",
				image_data_error: "either the file size exceeds the browser limit or the file may be corrupt.",
				corner_tooltip: "Drag corner to resize",
				handle_tooltip: "Drag handle to resize",
			},
		},
	},
};
